export default __webpack_public_path__ + "static/media/oci-training.0a641258.png";